<template>
  <div
    :class="['productList', { inApp: $root.$data.isApp||this.$root.miniprogram }]"
    id="yd-page5"
  >
    <common-title
      titleName="课程列表"
      :bcColor="'#FEFEFF'"
      :zIndex="1000"
    ></common-title>
    <div class="content">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :offset="20"
          v-if="courseList.length"
          @load="onLoad"
        >
          <ul class="courseList">
            <li
              v-for="(item, keys) in courseList"
              :key="keys"
            >
              <CombinationCard
                v-if="item.setType === 1"
                :item="item"
                :index="keys"
              />
              <HotCourseCard
                v-else
                :item="item"
                :key="keys"
              />
            </li>
          </ul>
        </van-list>
        <EmptyData
          :emptyName="'noProductList'"
          v-if="listEmpty"
        />
        <Foot />
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import { reqCombinationlist } from '@/api/combination';
// eslint-disable-next-line import/no-cycle
import {
  reqProducts, reqProductList, reqAdvertDetail, reqRecommendDetail
} from '@/api/home';
import { loadMantisChat } from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';
export default {
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
    Foot,
    CombinationCard,
  },
  data() {
    return {
      courseList: [], // 课程列表
      currentPage: 1,
      totalPages: 0, // 总页数
      loading: false,
      finished: false,
      refreshing: false,
      stopPropagation: true,
      listEmpty: false, // 在loading时不显示缺省页
      downLoad: false, // 下拉加载判断不触发缺省页
      recommendList: [],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    // this.$nextTick(() => {
    //   this.$refs.load.show = true;
    // });
    this.getCourse(this.currentPage, 12);
  },
  mounted() {
    // 小程序不需要客服
    if (!this.$root.$data?.miniprogram) {
      loadMantisChat(this.userInfo);
    }
  },
  methods: {
    // 每次向下滚动，滚动条与底部距离小于offset时触发
    onLoad() {
      const { type } = this.$route.query;
      if (Number(type) === 1) {
        this.finished = true;
        return;
      }
      this.downLoad = true;
      if (this.courseList.length >= this.totalPages) {
        // 如果没有数据需要加载了就显示没有更多了
        this.finished = true;
      } else {
        // 如果发现现有数组并没有达到总条数则加页继续发送请求
        this.currentPage += 1;
        this.getCourse(this.currentPage, 12);
      }
    },
    // 下拉刷新
    onRefresh() {
      const { type } = this.$route.query;
      if (Number(type) === 1) {
        this.refreshing = false;
        this.loading = false;
        return;
      }
      // 清空列表数据
      this.finished = false;

      this.downLoad = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.refreshing = true;
      this.currentPage = 1;
      this.getCourse(this.currentPage, 12);
    },
    // 请求产品列表
    async getCourse(pageNum, pageSize) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const {
        type, productId, productCategoryId, productAttributeJson, source,
      } = this.$route.query;
      let res = [];
      let recommendList = [];
      if (Number(type) === 1) {
        const fromAd = productId.indexOf('playing') > -1;
        if (fromAd) {
          res = await reqAdvertDetail(productId.slice(productId.indexOf('playing') + 7));
          recommendList = res?.data?.advertisingContentDetailVOList;
        } else if (source === 'search') {
          recommendList = JSON.parse(productId);
        } else {
          res = await reqRecommendDetail(productId);
          recommendList = res?.data?.recommendContentVOList;
          recommendList.forEach((item) => {
            Object.assign(item, { productType: item.recommendType });
          });
        }
        if (recommendList?.length) {
          this.recommendList = recommendList;
          const allProductIds = [];
          const allPackageIds = [];
          recommendList.forEach((item) => {
            if (item.productType === 0) {
              allProductIds.push(item.productId);
            } else {
              allPackageIds.push(item.productId);
            }
          });
          this.getCourseLists(allProductIds, allPackageIds);
        } else {
          this.listEmpty = true;
          this.refreshing = false;
        }
      } else if (Number(type) === 2) {
        const attributeReqVOList = [];
        if (productAttributeJson && productAttributeJson.length > 6) {
          JSON.parse(productAttributeJson).forEach((item) => {
            Object.assign(item, { attributeValue: item.attributeValue });
            attributeReqVOList.push(item);
          });
        }
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProductList({
          attributeReqVOList,
          productCategoryIds: [productCategoryId],
          pageNum,
          pageSize,
          endPoint,
          company: 0,
          isShow: 1,
        });
        if (res.code === 0 && res.data) {
          // 下拉加载时不执行
          if (!this.downLoad) {
            if (this.refreshing) {
              this.courseList = [];
            } else {
              // this.$refs.load.show = false;
            }
          }
          this.refreshing = false;
          this.loading = false;
          this.courseList = [...this.courseList, ...this.resetCourse(res.data.data || [])];
          if (!res.data.data.length) {
            this.listEmpty = true;
          }
          this.totalPages = res.data.total;
        } else {
          // this.$refs.load.show = false;
          this.listEmpty = true;
          this.refreshing = false;
        }
      } else if (Number(type) === 5) {
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProducts(productId.split(','), endPoint);
        if (res.code === 0 && res.data) {
          if (this.refreshing) {
            this.courseList = [];
          } else {
            // 初始请求是全局loading不显示，下拉时不需要加载全局loading
            // this.$refs.load.show = false;
          }
          this.refreshing = false;
          this.loading = false;
          this.courseList = [...this.courseList, ...this.resetCourse(res.data || [])];
          this.totalPages = res.data.length;
          if (!res.data.length) {
            this.listEmpty = true;
          }
        } else {
          // this.$refs.load.show = false;
          this.listEmpty = true;
          this.refreshing = false;
        }
      } else {
        const endPoint = this.$root.$data.isApp ? 2 : 4;
        res = await reqProductList({
          productCategoryIds: productCategoryId.split(','),
          pageNum,
          pageSize,
          endPoint,
          company: 0,
          isShow: 1,
        });
        if (res.code === 0 && res.data) {
          // 下拉加载时不执行
          if (!this.downLoad) {
            if (this.refreshing) {
              this.courseList = [];
            } else {
              // this.$refs.load.show = false;
            }
          }
          this.refreshing = false;
          this.loading = false;
          this.courseList = [...this.courseList, ...this.resetCourse(res.data.data || [])];
          if (!res.data.data.length) {
            this.listEmpty = true;
          }
          this.totalPages = res.data.total;
        } else {
          // this.$refs.load.show = false;
          this.listEmpty = true;
          this.refreshing = false;
        }
      }
      this.$toast.clear();
    },
    // 请求精选课程的课程卡片信息
    async getCourseLists(allProductIds, allPackageIds) {
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const p1 = allProductIds.length ? reqProducts(allProductIds, endPoint) : {};
      const p2 = allPackageIds.length ? reqCombinationlist(0, endPoint, allPackageIds) : {};
      Promise.all([p1, p2]).then((result) => {
        const res = result[0];
        const res1 = result[1];
        const resCourse = this.resetCourse(res?.data || []);
        const resPackage = this.resetCoursePackage(res1?.data || []);
        const courseList = [];
        this.recommendList.forEach((child) => {
          const findRes = [...resCourse, ...resPackage].find((course) => {
            const id = child.productType === 0 ? course.productId : course.packageId;
            return id === child.productId;
          });
          // eslint-disable-next-line no-unused-expressions
          findRes && courseList.push(findRes);
        });
        this.courseList = courseList;
      });
    },

    resetCourse(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach((item) => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount
          && item.sellPrice > 0
          && !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}
.productList {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 100px 36px 0 36px;
  background: #fefeff;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .content {
    height: 100%;
  }
  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0 100px 0;
    background: #fff;
  }

  .courseList > li {
    position: relative;
    width: 686px;
    // height: 3.06px;
    // border: 1px solid red;
    // display: flex;
    // flex-wrap: nowrap;
    margin: 0 auto;
    margin-bottom: 25px;
    padding: 0.32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    // box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
    opacity: 1;
    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }
  ::v-deep .common-foot {
    position: fixed;
  }
}
</style>
